import "./hamburger.css";

export default function Hamburger({ onClickHandler, open }: any) {
  return (
    <button className={`ae-hamburger-menu-container`} onClick={onClickHandler}>
      <div
        className={`ae-hamburger-menu-bar ${open ? "animation-tilt-down" : ""}`}
        data-testid="hamburger-bar"
      />
      <div
        className={`ae-hamburger-menu-bar ${open ? "animation-fade-out" : ""}`}
        data-testid="hamburger-bar"
      />
      <div
        className={`ae-hamburger-menu-bar ${open ? "animation-tilt-up" : ""}`}
        data-testid="hamburger-bar"
      />
    </button>
  );
}
